import { BACKEND_URL } from "../../constants/ApplicationConstants";

export function requestPasswordResetURL() {
    return BACKEND_URL + `/api/v1/auth/forgotpassword`;
}

export function resetPasswordURL(token) {
    return BACKEND_URL + `/api/v1/auth/resetpassword/${token}`;
}